import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface Props {
  creditPolicy: string[];
}

export const CreditPolicy: React.FC<Props> = ({ creditPolicy }) => {
  return creditPolicy.map((policy, index) => (
    <View key={`${policy.length}-${index}`} style={styles.policyItem}>
      <Typography variant="paragraph-base">•</Typography>
      <View style={styles.flex}>
        <Typography variant="paragraph-base">{policy}</Typography>
      </View>
    </View>
  ));
};

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  policyItem: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 8,
    paddingLeft: 8,
  },
});
